// Compare and save under a database row lock. Long text stays in the POST body.
export async function saveConsultationSource(client, patientId, item, changes) {
  if (item.type !== 'Consultation' || !item.id || !patientId) throw new Error('Select a transcription first.');
  if (!changes || typeof changes !== 'object' || Array.isArray(changes)
    || Object.keys(changes).some(field => !['transcription', 'notes'].includes(field) || typeof changes[field] !== 'string')) {
    throw new Error('Invalid transcription changes.');
  }
  if (!Object.keys(changes).length) return item.originalData;
  const { data, error, status } = await client.rpc('save_consultation_source', {
    p_patient_id: patientId,
    p_consultation_id: item.id,
    p_original_transcription: item.originalData?.transcription ?? '',
    p_original_notes: item.originalData?.notes ?? '',
    p_changes: changes,
  });
  if (error) {
    throw Object.assign(new Error('Changes could not be saved. Your edits are still here. Please retry.'), { code: error.code, status });
  }
  if (data === 'saved' || data === 'already_saved') return { ...item.originalData, ...changes };
  if (data === 'conflict') throw new Error('This transcription has changed. Reopen it before saving. Your edits are still here.');
  if (data === 'not_found') throw new Error('This transcription could not be loaded. Your edits are still here. Please reopen it.');
  throw new Error('Changes could not be confirmed. Your edits are still here. Please retry.');
}
